module.exports = __webpack_public_path__ + "static/slide2-c5ab674ed8d3d1e176b78b277306a678.webp";